

























import { getDefaultThumbnailForMediaType } from '@/web/utils/media';

export default {
  name: 'PlaylistTeacherThumbnail',
  props: {
    playlist: {
      type: Object,
    },
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    showTrashIcon: {
      type: Boolean,
      default: true,
    },
    showContentLength: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    backgroundImage(): object | null {
      const media = this.playlist?.cover_file || this.playlist?.media;
      const defaultThumbnail = getDefaultThumbnailForMediaType(
        this.playlist?.media?.file_content
      );

      if (media?.thumbnail) {
        const res = {
          backgroundImage: 'url(' + media.thumbnail + ')',
          backgroundSize: 'cover',
        };

        const { focal_point_x, focal_point_y } = media;
        if (focal_point_x && focal_point_y) {
          res.backgroundPosition = `${focal_point_x}% ${focal_point_y}%`;
        }

        return res;
      } else if (defaultThumbnail) {
        return {
          backgroundImage: 'url(' + defaultThumbnail + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        };
      } else {
        return {
          backgroundImage:
            'url(/assets/images/empty-media-thumbnails/playlists.svg)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        };
      }
    },
  },
  methods: {
    deletePlaylist(id) {
      this.$emit('deletePlaylist', id);
    },
  },
};
